/**
 * Created by jv on 2020-02-11 (14:47).
 */
import utils from "Sources/utils/utils";

import "Styles/components/search-input-expand.scss";

const COLLAPSED_CLASS = "search-input-collapsed";

class SearchInputExpand
{
  constructor(options)
  {
    // selector should be search-input-wrapper
    this.element = $(options.selector);
    this.setUpEventListeners();

    this.onSearchRequest = options.onSearchRequest;
  }

  setUpEventListeners()
  {
    this.element.find("input.form-control").on("blur", (e) =>
    {
      let $this = $(e.currentTarget);
      let inputValue = $this.val();

      if(utils.isNullOrEmpty(inputValue))
      {
        this.element.addClass(COLLAPSED_CLASS);
      }
    });

    this.element.find("input.form-control").on("keyup", (e) =>
    {
      let $this = $(e.currentTarget);

      if((utils.isNotNull(e.key)) || e.keyCode === 13)
      {
        if(utils.isFunction(this.onSearchRequest))
        {
          this.onSearchRequest.call(this, $this.val());
        }
      }
    });

    this.element.on("click", (e) =>
    {
      this.element.removeClass(COLLAPSED_CLASS);
      this.element.find("input.form-control").first().focus();
    });
  }
}

export default SearchInputExpand;



// WEBPACK FOOTER //
// ./app/js/components/search-input-expand.js